<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';
    import { LL } from '@i18n/i18n-svelte';
    import { URLS } from '@shared/routing';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';
    import { Size } from '@uikit/types';

    import s from '../error.module.css';

    import { goto } from '$app/navigation';
</script>

<div class={cn(s.root, { [s.desktop]: $globalStore.isDesktopSite })}>
    <div class={cn(s.content)}>
        <div class={cn(s.code404)}>
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.div}
                className={cn(s.digit, s.digitLeft)}
            >
                4
            </Font>
            <img src="/images/error/ufo-404.png" class={cn(s.img)} alt="404" />
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.div}
                className={cn(s.digit, s.digitRight)}
            >
                4
            </Font>
        </div>
        <Font
            type={FontTypes.Type.h3}
            tagName={FontTypes.TagName.div}
            isBold
            className={cn(s.title)}
        >
            {$LL.error.code404.title()}
        </Font>
        <Font type={FontTypes.Type.body} tagName={FontTypes.TagName.div}>
            {$LL.error.code404.description()}
        </Font>
    </div>
    <Button
        color={ButtonTypes.Color.Brand}
        size={Size.Big}
        fullWidth={!$globalStore.isDesktopSite}
        on:click={() => goto(URLS.index())}
    >
        {$LL.error.goToMainPage()}
    </Button>
</div>
